import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useIsVenueMode() {
    const route = useRoute();

    const isVenueModeOn = computed(() => route.path?.includes('/venue-mode'));

    return isVenueModeOn;
}
